<template>
    <div style="padding:10px">
        <el-collapse v-model="activeName" accordion @change="getTickets">
            <el-collapse-item :title="g.code + ' - ' + g.tickets_count + ' tickets' + '(P' + g.total_fare + ')'"
                :name="g.code" v-for="g in group_tickets" :key="g.code">
                <el-button @click="handlePrint(ticket)" v-for="ticket in tickets" :key="ticket.id" type="primary" size="large"
                    class="mb-2">PRINT {{ ticket.accommodation.code }} - {{ ticket.ticket_seat.seat_number
                    }}</el-button>
                <div style="text-align: center;"><el-button size="large" @click="handlePrintAll">PRINT ALL</el-button>
                </div>
            </el-collapse-item>
        </el-collapse>

        <el-drawer title="" :visible.sync="showPdf" direction="btt" :before-close="handleClose" size="90%"
            :append-to-body="true" :destroy-on-close="true">
            <TicketPdfViewer :url="url" v-if="url" @print="handleClose()"></TicketPdfViewer>
        </el-drawer>
    </div>

</template>

<script>

import {
    GroupTicket
} from '@/resources/group_ticket'


import {
    Ticket
} from '@/resources/ticket'
import TicketPdfViewer from '../../Ticketing/TicketPdfViewer.vue'

export default {
    components: { TicketPdfViewer },
    props: ['booking'],
    data() {
        return {
            group_tickets: [],
            activeName: "1",
            tickets: [],
            showPdf: false,
            url: null
        }
    },
    created: function () {
        this.getTransactions()
    },
    methods: {
        getTransactions() {
            let params = {
                page: 1,
                per_page: 999,
                status: 2,
                transaction_date: this.$moment().format('YYYY-MM-DD'),
                booking_id: this.booking.id
            }
            this.$loading = true
            GroupTicket.userTransactions(params)
                .then(result => {
                    if (result.data.group_tickets)
                        this.group_tickets = result.data.group_tickets
                })
                .catch(() => {

                }).finally(() => {
                    this.$loading = false
                })
        },
        getTickets() {
            if (!this.activeName) return

            let params = {
                per_page: 999,
                group_ticket_code: this.activeName,
                basic: true
            }
            this.$loading = true
            Ticket.get(params)
                .then(result => {
                    this.tickets = result.data.tickets
                })
                .catch(() => {

                }).finally(() => {
                    this.$loading = false
                })
        },
        handlePrint(ticket) {
            this.$loading = true
            this.$loadingText = "Preparing to generate ticket"

            Ticket.downloadTicket(ticket.id)
                .then(result => {
                    this.url = result.data.url
                    this.showPdf = true
                })
                .catch(() => {

                }).finally(() => {
                    this.$loading = false
                })
        },
        handlePrintAll() {
            this.$loading = true
            this.$loadingText = "Preparing to generate ticket"

            Ticket.downloadTickets({
                group_ticket_code: this.activeName
            })
                .then(result => {
                    this.url = result.data.url
                    this.showPdf = true
                })
                .catch(() => {

                }).finally(() => {
                    this.$loading = false
                })
        },
        handleClose() {
            this.showPdf = false
        },
    }
}
</script>

<style lang="scss"></style>
